var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('oil-form',{attrs:{"keys":_vm.keys,"items":_vm.report,"createForm":true,"title":'ОТЧЕТЫ общий'.toUpperCase(),"formCallback":_vm.formCallback},scopedSlots:_vm._u([{key:"saveBtn",fn:function(ref){
var input = ref.input;
var method = ref.method;
return [_c('v-btn',{attrs:{"disaled":"","color":"primary","loading":input.isLoading,"disabled":!input.isLoading && !_vm.report.Names},on:{"click":method.action}},[_vm._v(" ЗАГРУЗИТЬ ")])]}},{key:"closeBtn",fn:function(ref){
var method = ref.method;
var input = ref.input;
return [_c('v-btn',{attrs:{"text":"","color":"normal","disabled":!input.isLoading && !input.isEdit},on:{"click":method.action}},[_vm._v(" Назад ")])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }